import { Box } from '@wishket/design-system';

import { Skeleton } from '@/shared/Components';

export const CollectionDetailSkeleton = () => {
  return (
    <Box className="grid-in-content">
      <CollectionDetailListSkeleton />
    </Box>
  );
};

export const CollectionDetailListSkeleton = () => {
  return (
    <Skeleton className="flex min-h-full min-w-full flex-col gap-8 ">
      {Array.from({ length: 10 }).map((_, index) => (
        <Box
          key={index}
          className="h-[156px] w-full rounded-3xl bg-w-gray-50 desktop:h-[184px]"
        />
      ))}
    </Skeleton>
  );
};
